import axios from 'axios'

const url = 'linkdrive/plataforma/acesso-publico/arquivo/lista'
const urlP = 'linkdrive/plataforma/acesso-privado/arquivo/lista'

const state = {
  arquivos: []
}

const getters = {
  arquivos: state => state.arquivos,
}

const mutations = {
  setArquivos: (state, payload) => state.arquivos = payload,
}

const actions = {
  async getArquivos({ commit }) {
    const { data: arquivos } = await axios(`${url}/50/pagina/1`)
    commit('setArquivos', arquivos)
  },
  async getArquivosPrivado({ commit }) {
    const { data: arquivos } = await axios(`${urlP}/50/pagina/1`)
    commit('setArquivos', arquivos)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}